import { DependencyType } from '../../api/model';

export const DEPENDENCY_TYPE_LABELS: Record<string, string> = {
  [DependencyType.MUST_FINISH_FIRST]: 'Must finish first',
  [DependencyType.CAN_START_IN_PARALLEL]: 'Can start in parallel',
  [DependencyType.INFORMATIONAL]: 'Informational link only',
};

export const DEPENDENCY_TYPE_SHORT: Record<string, string> = {
  [DependencyType.MUST_FINISH_FIRST]: 'FS',
  [DependencyType.CAN_START_IN_PARALLEL]: 'SS',
  [DependencyType.INFORMATIONAL]: 'INFO',
};

export const getDependencyTypeLabel = (type?: string): string =>
  (type && DEPENDENCY_TYPE_LABELS[type]) || 'Informational link only';

export const getDependencyTypeShort = (type?: string): string =>
  (type && DEPENDENCY_TYPE_SHORT[type]) || 'INFO';

export const formatOffsetDays = (offsetDays?: number): string => {
  const value = offsetDays ?? 0;
  if (value > 0) return `+${value}d`;
  return `${value}d`;
};
